"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const react_dom_1 = __importDefault(require("react-dom"));
const config_1 = require("../../../lib/constants/config");
/**
 * Creates portal for rendering add to calendar & print cta in portal
 * for mobile view
 *
 * @param {Object} props - The component props.
 * @param {boolean} props.aboveMd - flag to check if the screen size is above md
 * @param {React.JSX.Element} props.children - children to be rendered in portal
 * @param {string} props.target - id of the target container where portal has to be created
 * @param {boolean} props.bodyIsAnimating - id of the target container where portal has to be created
 * @returns {React.JSX.Element} The rendered portal component.
 */
const SummaryCtaPortal = ({ aboveMd, children, target, bodyIsAnimating = false }) => {
    const portalContainer = document.getElementById(target || config_1.DIRECT_BOOK_CONTAINER_ID);
    if (!bodyIsAnimating && portalContainer !== null && aboveMd === false) {
        return react_dom_1.default.createPortal(children, portalContainer);
    }
    return children;
};
SummaryCtaPortal.propTypes = {
    aboveMd: prop_types_1.default.bool.isRequired,
    target: prop_types_1.default.string,
    children: prop_types_1.default.node.isRequired
};
exports.default = SummaryCtaPortal;
//# sourceMappingURL=SummaryCtaPortal.js.map